<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      color="primary"
      :absolute="$vuetify.breakpoint.mobile"
      :temporary="$vuetify.breakpoint.mobile"
      :app="!$vuetify.breakpoint.mobile"
      :permanent="!$vuetify.breakpoint.mobile"
      dark
    >
      <v-row justify="center">
        <v-col cols="8" class="text-center">
          <v-avatar max-width="100%" width="100%" height="auto">
            <PatientPicture :avatar="patient.avatar" />
          </v-avatar>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="font-weight-bold text-center white--text">
          {{ patient.name }}
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-center white--text">
          {{ patient.birthDate | moment("DD/MM/Y") }}
        </v-col>
      </v-row>

      <v-list class="white--text">
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link to="/paciente/atestados" v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon>eva-file-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content> Atestados </v-list-item-content>
            </v-list-item>
          </template>

          <span>Atestados</span>
        </v-tooltip>

        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link to="/paciente/exames" v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon>ri-flask-line</v-icon>
              </v-list-item-icon>

              <v-list-item-content> Exames </v-list-item-content>
            </v-list-item>
          </template>

          <span>Exames</span>
        </v-tooltip>

        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item link to="/paciente/receitas" v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon>ri-capsule-fill</v-icon>
              </v-list-item-icon>

              <v-list-item-content> Receitas </v-list-item-content>
            </v-list-item>
          </template>

          <span>Receitas</span>
        </v-tooltip>

        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              link
              to="/paciente/receitas-oculos"
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon>ri-spy-line</v-icon>
              </v-list-item-icon>

              <v-list-item-content> Receitas de óculos </v-list-item-content>
            </v-list-item>
          </template>

          <span>Receitas de óculos</span>
        </v-tooltip>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="white" flat app>
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer"> </v-app-bar-nav-icon> -->

      <v-row dense align="center">
        <v-col cols="auto" v-if="$vuetify.breakpoint.mobile">
          <v-icon @click="drawer = !drawer">ri-menu-line</v-icon>
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="auto" class="font-weight-bold">
          {{ patient.name }}
        </v-col>

        <v-col cols="auto">
          <v-menu offset-y bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-on="on" :attrs="attrs">
                <v-avatar size="40">
                  <PatientPicture
              :avatar="attendance.patient.avatar"
              />
                </v-avatar>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="logout">
                <v-list-item-title> Logout </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-app-bar>

    <transition name="slide-fade">
      <v-container fluid>
        <v-row>
          <v-col>
            <router-view v-if="patient.id" :patient="patient" />
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import PatientPicture from "@/components/queues/attendance/patient_picture.vue"
export default {
  name: "Patient",
  components: {
    PatientPicture,
  },
  data() {
    return {
      patient: {},
      drawer: false,
    };
  },
  apollo: {
    patient: {
      query: require("@/graphql/patients/patient_zone.gql"),
      variables() {
        return {
          patientId: this.patientId,
        };
      },
      pollInterval: 1000,
      update(data) {
        this.$store.dispatch("authentication/refreshToken");
        return data.patient;
      },
    },
  },
  computed: {
    patientId() {
      let tokenPayload = this.$store.getters["authentication/tokenPayload"];

      return tokenPayload.patient_id;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/signOut").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
